// extracted by mini-css-extract-plugin
export default {"root":"CodeExpandable_root__YGm7u"};